import React, { useState } from 'react';
import { PlayingCard } from './PlayingCard';
interface HandInfo {
  id: string;
  name: string;
  english: string;
  chips: number;
  mult: number;
  description: string;
  example: Array<{
    rank: string;
    suit: string;
  }>;
  tip: string;
  emoji: string;
  rarity: 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary';
}
const hands: HandInfo[] = [{
  id: 'high-card',
  name: '高牌',
  english: 'High Card',
  chips: 5,
  mult: 1,
  description: '5张牌中没有任何组合，只有最大的那张牌算数。这是最弱的牌型。',
  example: [{
    rank: 'A',
    suit: '♠'
  }, {
    rank: '9',
    suit: '♥'
  }, {
    rank: '7',
    suit: '♦'
  }, {
    rank: '4',
    suit: '♣'
  }, {
    rank: '2',
    suit: '♠'
  }],
  tip: '虽然是最弱的牌型，但配合强力小丑牌也能打出高分！',
  emoji: '🃏',
  rarity: 'common'
}, {
  id: 'one-pair',
  name: '一对',
  english: 'One Pair',
  chips: 10,
  mult: 2,
  description: '5张牌中有2张点数相同的牌（一对）。',
  example: [{
    rank: 'K',
    suit: '♥'
  }, {
    rank: 'K',
    suit: '♠'
  }, {
    rank: '9',
    suit: '♦'
  }, {
    rank: '5',
    suit: '♣'
  }, {
    rank: '2',
    suit: '♥'
  }],
  tip: '两张K就是一对K，是最常见的牌型之一。',
  emoji: '👥',
  rarity: 'common'
}, {
  id: 'two-pair',
  name: '两对',
  english: 'Two Pair',
  chips: 20,
  mult: 2,
  description: '5张牌中有两组不同的对子。',
  example: [{
    rank: 'Q',
    suit: '♥'
  }, {
    rank: 'Q',
    suit: '♦'
  }, {
    rank: '8',
    suit: '♠'
  }, {
    rank: '8',
    suit: '♣'
  }, {
    rank: 'A',
    suit: '♥'
  }],
  tip: '两对Q和两对8，比单独一对要强！',
  emoji: '👥👥',
  rarity: 'common'
}, {
  id: 'three-of-a-kind',
  name: '三条',
  english: 'Three of a Kind',
  chips: 30,
  mult: 3,
  description: '5张牌中有3张点数相同的牌。',
  example: [{
    rank: 'J',
    suit: '♠'
  }, {
    rank: 'J',
    suit: '♥'
  }, {
    rank: 'J',
    suit: '♦'
  }, {
    rank: '7',
    suit: '♣'
  }, {
    rank: '3',
    suit: '♠'
  }],
  tip: '三张J！三条的倍率（×3）比两对更高。',
  emoji: '🎯',
  rarity: 'uncommon'
}, {
  id: 'straight',
  name: '顺子',
  english: 'Straight',
  chips: 30,
  mult: 4,
  description: '5张牌的点数连续，但花色不同。A可以作为最大（A-K-Q-J-10）或最小（A-2-3-4-5）。',
  example: [{
    rank: '9',
    suit: '♠'
  }, {
    rank: '8',
    suit: '♥'
  }, {
    rank: '7',
    suit: '♦'
  }, {
    rank: '6',
    suit: '♣'
  }, {
    rank: '5',
    suit: '♠'
  }],
  tip: '5-6-7-8-9 连续五张，就是顺子！注意花色可以不同。',
  emoji: '📈',
  rarity: 'uncommon'
}, {
  id: 'flush',
  name: '同花',
  english: 'Flush',
  chips: 35,
  mult: 4,
  description: '5张牌的花色全部相同，但点数不需要连续。',
  example: [{
    rank: 'A',
    suit: '♥'
  }, {
    rank: 'J',
    suit: '♥'
  }, {
    rank: '8',
    suit: '♥'
  }, {
    rank: '5',
    suit: '♥'
  }, {
    rank: '2',
    suit: '♥'
  }],
  tip: '全部都是红心♥，就是同花！花色相同是关键。',
  emoji: '❤️',
  rarity: 'uncommon'
}, {
  id: 'full-house',
  name: '葫芦',
  english: 'Full House',
  chips: 40,
  mult: 4,
  description: '5张牌中有3张相同点数 + 2张相同点数（三条 + 一对）。',
  example: [{
    rank: '10',
    suit: '♠'
  }, {
    rank: '10',
    suit: '♥'
  }, {
    rank: '10',
    suit: '♦'
  }, {
    rank: '6',
    suit: '♣'
  }, {
    rank: '6',
    suit: '♥'
  }],
  tip: '三张10 + 两张6 = 葫芦！三条和一对的完美组合。',
  emoji: '🏠',
  rarity: 'rare'
}, {
  id: 'four-of-a-kind',
  name: '四条',
  english: 'Four of a Kind',
  chips: 60,
  mult: 7,
  description: '5张牌中有4张点数相同的牌。',
  example: [{
    rank: 'A',
    suit: '♠'
  }, {
    rank: 'A',
    suit: '♥'
  }, {
    rank: 'A',
    suit: '♦'
  }, {
    rank: 'A',
    suit: '♣'
  }, {
    rank: 'K',
    suit: '♠'
  }],
  tip: '四张A！这是非常强的牌型，×7的倍率非常可观。',
  emoji: '💪',
  rarity: 'rare'
}, {
  id: 'straight-flush',
  name: '同花顺',
  english: 'Straight Flush',
  chips: 100,
  mult: 8,
  description: '5张牌既是顺子（连续点数），又是同花（相同花色）。',
  example: [{
    rank: '9',
    suit: '♣'
  }, {
    rank: '8',
    suit: '♣'
  }, {
    rank: '7',
    suit: '♣'
  }, {
    rank: '6',
    suit: '♣'
  }, {
    rank: '5',
    suit: '♣'
  }],
  tip: '全是梅花♣，而且5-6-7-8-9连续！同花顺极其强力。',
  emoji: '⚡',
  rarity: 'epic'
}, {
  id: 'royal-flush',
  name: '皇家同花顺',
  english: 'Royal Flush',
  chips: 100,
  mult: 8,
  description: '最高的同花顺：A-K-Q-J-10，且全部同花色。传统扑克中最强的牌型！',
  example: [{
    rank: 'A',
    suit: '♦'
  }, {
    rank: 'K',
    suit: '♦'
  }, {
    rank: 'Q',
    suit: '♦'
  }, {
    rank: 'J',
    suit: '♦'
  }, {
    rank: '10',
    suit: '♦'
  }],
  tip: '方块A-K-Q-J-10，传统扑克中的终极牌型！',
  emoji: '👑',
  rarity: 'epic'
}, {
  id: 'five-of-a-kind',
  name: '五条',
  english: 'Five of a Kind',
  chips: 120,
  mult: 12,
  description: '【小丑牌专属】5张点数完全相同的牌。需要借助小丑牌的特殊能力才能实现！',
  example: [{
    rank: 'K',
    suit: '♠'
  }, {
    rank: 'K',
    suit: '♥'
  }, {
    rank: 'K',
    suit: '♦'
  }, {
    rank: 'K',
    suit: '♣'
  }, {
    rank: 'K',
    suit: '♥'
  }],
  tip: '小丑牌独有！普通扑克牌中不存在，需要特殊小丑牌的加持。',
  emoji: '🌟',
  rarity: 'legendary'
}, {
  id: 'flush-house',
  name: '同花葫芦',
  english: 'Flush House',
  chips: 140,
  mult: 14,
  description: '【小丑牌专属】葫芦（三条+一对）且全部同花色。',
  example: [{
    rank: '7',
    suit: '♥'
  }, {
    rank: '7',
    suit: '♥'
  }, {
    rank: '7',
    suit: '♥'
  }, {
    rank: '3',
    suit: '♥'
  }, {
    rank: '3',
    suit: '♥'
  }],
  tip: '同花葫芦！葫芦的升级版，需要特殊条件达成。',
  emoji: '🔥',
  rarity: 'legendary'
}, {
  id: 'flush-five',
  name: '同花五条',
  english: 'Flush Five',
  chips: 160,
  mult: 16,
  description: '【小丑牌专属】5张点数相同且花色相同的牌。游戏中最强的牌型！',
  example: [{
    rank: 'A',
    suit: '♠'
  }, {
    rank: 'A',
    suit: '♠'
  }, {
    rank: 'A',
    suit: '♠'
  }, {
    rank: 'A',
    suit: '♠'
  }, {
    rank: 'A',
    suit: '♠'
  }],
  tip: '游戏中最强的牌型！配合强力小丑牌可以打出天文数字的分数！',
  emoji: '💫',
  rarity: 'legendary'
}];
const rarityColors = {
  common: {
    bg: 'rgba(100,100,120,0.2)',
    border: 'rgba(150,150,170,0.4)',
    label: '#a0a0c0',
    text: '普通'
  },
  uncommon: {
    bg: 'rgba(50,150,50,0.15)',
    border: 'rgba(80,200,80,0.4)',
    label: '#60c060',
    text: '不常见'
  },
  rare: {
    bg: 'rgba(50,80,200,0.15)',
    border: 'rgba(80,120,255,0.4)',
    label: '#6090ff',
    text: '稀有'
  },
  epic: {
    bg: 'rgba(120,50,200,0.15)',
    border: 'rgba(160,80,255,0.4)',
    label: '#b060ff',
    text: '史诗'
  },
  legendary: {
    bg: 'rgba(200,150,0,0.15)',
    border: 'rgba(255,200,0,0.4)',
    label: '#FFD700',
    text: '传说'
  }
};
export function HandRankings() {
  const [selectedHand, setSelectedHand] = useState<string | null>('high-card');
  const [filter, setFilter] = useState<'all' | 'balatro'>('all');
  const filteredHands = filter === 'balatro' ? hands.filter(h => ['five-of-a-kind', 'flush-house', 'flush-five'].includes(h.id)) : hands;
  const selected = hands.find(h => h.id === selectedHand);
  return <div className="space-y-6" data-id="element-56">
      <div className="flex gap-3 mb-4" data-id="element-57">
        <button onClick={() => setFilter('all')} className={`nav-tab ${filter === 'all' ? 'active' : ''}`} data-id="element-58">
          全部牌型
        </button>
        <button onClick={() => setFilter('balatro')} className={`nav-tab ${filter === 'balatro' ? 'active' : ''}`} data-id="element-59">
          🃏 小丑牌专属
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-60">
        {/* Hand list */}
        <div className="space-y-2" data-id="element-61">
          <p className="text-xs mb-3" style={{
          color: '#9080b0'
        }} data-id="element-62">
            点击牌型查看详情和示例：
          </p>
          {filteredHands.map((hand, index) => {
          const rarity = rarityColors[hand.rarity];
          const isSelected = selectedHand === hand.id;
          return <button key={hand.id} onClick={() => setSelectedHand(hand.id)} className="w-full text-left p-3 rounded-lg transition-all duration-200 hand-row" style={{
            background: isSelected ? rarity.bg : 'rgba(0,0,0,0.2)',
            border: `1px solid ${isSelected ? rarity.border : 'rgba(255,255,255,0.05)'}`,
            boxShadow: isSelected ? `0 0 15px ${rarity.border}` : 'none'
          }} data-id="element-63">
                <div className="flex items-center justify-between" data-id="element-64">
                  <div className="flex items-center gap-2" data-id="element-65">
                    <span className="text-lg" data-id="element-66">{hand.emoji}</span>
                    <div data-id="element-67">
                      <div className="font-bold text-sm" style={{
                    color: isSelected ? rarity.label : '#d0b0ff',
                    fontFamily: 'Cinzel, serif'
                  }} data-id="element-68">
                        {hand.name}
                      </div>
                      <div className="text-xs" style={{
                    color: '#7060a0'
                  }} data-id="element-69">
                        {hand.english}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-70">
                    <span className="chip-badge px-2 py-0.5 rounded text-xs number-mono" data-id="element-71">
                      {hand.chips}
                    </span>
                    <span className="text-xs" style={{
                  color: '#7060a0'
                }} data-id="element-72">
                      ×
                    </span>
                    <span className="mult-badge px-2 py-0.5 rounded text-xs number-mono" data-id="element-73">
                      {hand.mult}
                    </span>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Detail panel */}
        {selected && <div className="panel p-5 sticky top-4" style={{
        height: 'fit-content'
      }} data-id="element-74">
            <div className="flex items-center gap-2 mb-3" data-id="element-75">
              <span className="text-2xl" data-id="element-76">{selected.emoji}</span>
              <div data-id="element-77">
                <h3 className="font-bold text-lg" style={{
              color: '#FFD700',
              fontFamily: 'Cinzel, serif'
            }} data-id="element-78">
                  {selected.name}
                </h3>
                <div className="flex items-center gap-2" data-id="element-79">
                  <span className="text-xs px-2 py-0.5 rounded" style={{
                background: rarityColors[selected.rarity].bg,
                border: `1px solid ${rarityColors[selected.rarity].border}`,
                color: rarityColors[selected.rarity].label
              }} data-id="element-80">
                    {rarityColors[selected.rarity].text}
                  </span>
                  {['five-of-a-kind', 'flush-house', 'flush-five'].includes(selected.id) && <span className="text-xs px-2 py-0.5 rounded" style={{
                background: 'rgba(180,79,255,0.2)',
                border: '1px solid rgba(180,79,255,0.5)',
                color: '#b44fff'
              }} data-id="element-81">
                      小丑牌专属
                    </span>}
                </div>
              </div>
            </div>

            {/* Score display */}
            <div className="flex items-center gap-2 mb-4 p-3 rounded-lg" style={{
          background: 'rgba(0,0,0,0.3)'
        }} data-id="element-82">
              <div className="text-center" data-id="element-83">
                <div className="text-xs mb-1" style={{
              color: '#9080b0'
            }} data-id="element-84">
                  基础筹码
                </div>
                <div className="chip-badge px-3 py-1 rounded-lg text-lg number-mono" data-id="element-85">
                  {selected.chips}
                </div>
              </div>
              <div className="text-xl" style={{
            color: '#7060a0'
          }} data-id="element-86">
                ×
              </div>
              <div className="text-center" data-id="element-87">
                <div className="text-xs mb-1" style={{
              color: '#9080b0'
            }} data-id="element-88">
                  基础倍率
                </div>
                <div className="mult-badge px-3 py-1 rounded-lg text-lg number-mono" data-id="element-89">
                  {selected.mult}
                </div>
              </div>
              <div className="text-xl" style={{
            color: '#7060a0'
          }} data-id="element-90">
                =
              </div>
              <div className="text-center" data-id="element-91">
                <div className="text-xs mb-1" style={{
              color: '#9080b0'
            }} data-id="element-92">
                  基础分数
                </div>
                <div className="score-badge px-3 py-1 rounded-lg text-lg number-mono" data-id="element-93">
                  {selected.chips * selected.mult}
                </div>
              </div>
            </div>

            {/* Description */}
            <p className="text-sm mb-4" style={{
          color: '#c0a0e0'
        }} data-id="element-94">
              {selected.description}
            </p>

            {/* Example cards */}
            <div className="mb-4" data-id="element-95">
              <p className="text-xs mb-2" style={{
            color: '#9080b0'
          }} data-id="element-96">
                示例牌型：
              </p>
              <div className="flex gap-2 flex-wrap" data-id="element-97">
                {selected.example.map((card, i) => <PlayingCard key={i} rank={card.rank} suit={card.suit} size="sm" highlighted data-id="element-98" />)}
              </div>
            </div>

            {/* Tip */}
            <div className="p-3 rounded-lg text-xs" style={{
          background: 'rgba(255,215,0,0.05)',
          border: '1px solid rgba(255,215,0,0.2)',
          color: '#c0a060'
        }} data-id="element-99">
              💡 {selected.tip}
            </div>
          </div>}
      </div>

      {/* Ranking summary table */}
      <div className="section-divider" data-id="element-100" />
      <div data-id="element-101">
        <h4 className="text-sm font-bold mb-3" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-102">
          📊 牌型强度总览（从弱到强）
        </h4>
        <div className="overflow-x-auto" data-id="element-103">
          <table className="w-full text-xs" style={{
          borderCollapse: 'separate',
          borderSpacing: '0 4px'
        }} data-id="element-104">
            <thead data-id="element-105">
              <tr style={{
              color: '#9080b0'
            }} data-id="element-106">
                <th className="text-left p-2" data-id="element-107">排名</th>
                <th className="text-left p-2" data-id="element-108">牌型</th>
                <th className="text-center p-2" data-id="element-109">基础筹码</th>
                <th className="text-center p-2" data-id="element-110">基础倍率</th>
                <th className="text-center p-2" data-id="element-111">基础分数</th>
              </tr>
            </thead>
            <tbody data-id="element-112">
              {hands.map((hand, i) => {
              const rarity = rarityColors[hand.rarity];
              return <tr key={hand.id} onClick={() => setSelectedHand(hand.id)} className="cursor-pointer transition-all duration-200" style={{
                background: selectedHand === hand.id ? rarity.bg : 'rgba(0,0,0,0.2)',
                border: `1px solid ${selectedHand === hand.id ? rarity.border : 'transparent'}`
              }} data-id="element-113">
                    <td className="p-2 rounded-l-lg" style={{
                  color: '#7060a0'
                }} data-id="element-114">
                      #{i + 1}
                    </td>
                    <td className="p-2" data-id="element-115">
                      <span className="font-bold" style={{
                    color: rarity.label,
                    fontFamily: 'Cinzel, serif'
                  }} data-id="element-116">
                        {hand.emoji} {hand.name}
                      </span>
                    </td>
                    <td className="p-2 text-center" data-id="element-117">
                      <span className="chip-badge px-2 py-0.5 rounded number-mono" data-id="element-118">
                        {hand.chips}
                      </span>
                    </td>
                    <td className="p-2 text-center" data-id="element-119">
                      <span className="mult-badge px-2 py-0.5 rounded number-mono" data-id="element-120">
                        ×{hand.mult}
                      </span>
                    </td>
                    <td className="p-2 text-center rounded-r-lg" data-id="element-121">
                      <span className="score-badge px-2 py-0.5 rounded number-mono" data-id="element-122">
                        {hand.chips * hand.mult}
                      </span>
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}